import React from 'react';
import { ReactComponent as ArrowRightIconSVG } from '../../assets/icons/mevo/ic_arrow_filled_right.svg';
import IconPattern, { IconProps } from './_IconPattern';

const ArrowRightFilledIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={ArrowRightIconSVG} variantPlaces={[]} {...props} />;
};
export default ArrowRightFilledIcon;
